import React from 'react';

interface Props {
  data: {
    companyName: string;
    industry: string;
    website: string;
  };
  updateData: (data: Partial<typeof Props['data']>) => void;
}

export const CompanyOverview = ({ data, updateData }: Props) => {
  const industries = [
    'IT',
    'Finance',
    'Manufacturing',
    'Education',
    'Healthcare',
    'Other'
  ];

  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-6">
        Tell us about your company
      </h2>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Company Name
            </label>
            <input
              type="text"
              value={data.companyName}
              onChange={(e) => updateData({ companyName: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="Enter company name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Industry
            </label>
            <select
              value={data.industry}
              onChange={(e) => updateData({ industry: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            >
              <option value="">Select industry</option>
              {industries.map((industry) => (
                <option key={industry} value={industry}>
                  {industry}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Company Website (optional)
          </label>
          <input
            type="url"
            value={data.website}
            onChange={(e) => updateData({ website: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            placeholder="https://"
          />
        </div>
      </div>
    </div>
  );
};